import { render, staticRenderFns } from "./RandomBlog.vue?vue&type=template&id=4731bd50&scoped=true"
import script from "./RandomBlog.vue?vue&type=script&lang=js"
export * from "./RandomBlog.vue?vue&type=script&lang=js"
import style0 from "./RandomBlog.vue?vue&type=style&index=0&id=4731bd50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731bd50",
  null
  
)

export default component.exports